(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evil-accessoires-premium"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-sacs-luxe"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
if (!customElements.get('evil-bags-count-sync')) {
  class EvilBagsCountSync extends HTMLElement {
    connectedCallback() {
      this.brand = this.brand || 'all';
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateCount(); });
      };
      this.onChange = event => {
        if (event.target.matches('.evil-bags-brand-radio')) this.brand = event.target.value;
        this.schedule();
      };
      this.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-bags-identity']});
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    updateCount() {
      const radio = Array.from(this.querySelectorAll('.evil-bags-brand-radio')).find(input => input.value === this.brand);
      if (radio) radio.checked = true;
      const cards = Array.from(this.querySelectorAll('.product-grid__item[data-bags-identity]'));
      const count = cards.filter(card => !card.hidden && getComputedStyle(card).display !== 'none').length;
      const en = this.dataset.language === 'en';
      const label = en ? `${count} ${count === 1 ? 'item' : 'items'}` : `${count} ${count === 1 ? 'article' : 'articles'}`;
      this.querySelectorAll('.products-count-wrapper [role="status"]').forEach(node => {
        if (node.textContent.trim() !== label) node.textContent = label;
      });
      this.querySelectorAll('.facets__see-results').forEach(button => {
        const text = en ? `See ${count} ${count === 1 ? 'item' : 'items'}` : `Voir ${count} ${count === 1 ? 'article' : 'articles'}`;
        if (button.textContent.trim() !== text) button.textContent = text;
      });
    }
  }
  customElements.define('evil-bags-count-sync', EvilBagsCountSync);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
